'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VERSION = exports.VERSION = '0.0.3';